const digest = '8c2ab7d09dccb132fc51c9bd22290c640a2f6105eb824aee3e3e4bafd834d4ea';
const css = `._offlineWarning_1hcod_1{left:5%;position:fixed;top:1rem;width:90%;z-index:1002}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'offlineWarning': '_offlineWarning_1hcod_1' };
export const offlineWarning = '_offlineWarning_1hcod_1';
export { css, digest };